/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { encodeBase64 } from "../../utils/utilityFunctions"
import { CALL_API } from "../middleware"
import { CONTENT_TYPE } from "../../utils/constant"
import { APPROVAL_LIST, APPROVAL_LIST_SUCCESS, APPROVAL_STATUS_FILTER, APPROVAL_STATUS_FILTER_SUCCESS, ApprovalStatuFilter, CHECKER_DETAILS, CHECKER_DETAILS_SUCCESS, CHECKER_OFFLINE_PAYMENT_APPROVAL, CHECKER_OFFLINE_PAYMENT_APPROVAL_SUCCESS, CHECKER_ORDER_APPROVAL, CHECKER_ORDER_APPROVAL_SUCCESS, CHECKER_ORDER_DETAILS, CHECKER_ORDER_DETAILS_SUCCESS, CHECKER_PAYMENT_APPROVAL, CHECKER_PAYMENT_APPROVAL_SUCCESS, CheckerOrderApprovalReq, CheckerOrderApprovalRes, CheckerOrderDetailsReq, CheckerOrderDetailsRes, OfflinePaymentApprovalReq, OfflinePaymentApprovalRes, ORDER_APPROVAL_EXCEL_REPORT, ORDER_APPROVAL_EXCEL_REPORT_SUCCESS, OrderApprovalExcelReportReq, OrderApprovalListReq, PAYMENT_APPROVAL_EXCEL_REPORT, PAYMENT_APPROVAL_EXCEL_REPORT_SUCCESS, PAYMENT_APPROVAL_LIST, PAYMENT_APPROVAL_LIST_SUCCESS, PAYMENT_DETAILS, PAYMENT_DETAILS_SUCCESS, PaymentApprovalExcelReportReq, PaymentApprovalListReq, PaymentApprovalListRes, PaymentsApprovalReq, SETTLEMENT_APPROVAL_EXCEL_REPORT, SETTLEMENT_APPROVAL_EXCEL_REPORT_SUCCESS, SETTLEMENT_APPROVAL_LIST, SETTLEMENT_APPROVAL_LIST_SUCCESS, SettlementApprovalExcelReportReq, SettlementApprovalListReq, SettlementApprovalListRes, CHECKER_SETTLEMENT_APPROVAL, CHECKER_SETTLEMENT_APPROVAL_SUCCESS, SettlementApprovalReq } from "../types/orderApproval";
import { OrderHistoryRes } from "../types/orderManagement";

export const getAprovalStatusFilter =
    () =>
        async (dispatch: any): Promise<ApprovalStatuFilter> => {
            return await dispatch({
                [CALL_API]: {
                    url: '/onboarding/nonMfTransactions/getApprovalStatusFilter',
                    method: 'GET',
                    types: [APPROVAL_STATUS_FILTER_SUCCESS, APPROVAL_STATUS_FILTER],
                },
            });
        };

export const getOrderApprovalList =
    (body: OrderApprovalListReq) =>
        async (dispatch: any): Promise<OrderHistoryRes> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/nonMfTransactions/orderApprovalList`,
                    method: 'POST',
                    types: [APPROVAL_LIST_SUCCESS, APPROVAL_LIST],
                    // body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                    body
                },
            });
        };

export const getCheckOrderApproval =
    (body: CheckerOrderApprovalReq) =>
        async (dispatch: any): Promise<CheckerOrderApprovalRes> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/nonMfTransactions/checkerOrderApproval`,
                    method: 'POST',
                    types: [CHECKER_ORDER_APPROVAL_SUCCESS, CHECKER_ORDER_APPROVAL],
                    // body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                    body
                },
            });
        };


export const getCheckOrderDetails =
    (body: CheckerOrderDetailsReq) =>
        async (dispatch: any): Promise<CheckerOrderDetailsRes> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/nonMfTransactions/getOrderDetails`,
                    method: 'POST',
                    types: [CHECKER_ORDER_DETAILS_SUCCESS, CHECKER_ORDER_DETAILS],
                    // body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                    body
                },
            });
        };

export const getCheckerDetails =
    () =>
        async (dispatch: any): Promise<any> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/dashboard/getCheckerDetails`,
                    method: 'GET',
                    types: [CHECKER_DETAILS_SUCCESS, CHECKER_DETAILS],
                },
            });
        };


export const getPaymentApprovalList =
    (body: PaymentApprovalListReq) =>
        async (dispatch: any): Promise<PaymentApprovalListRes> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/nonMfTransactions/paymentApprovalList`,
                    method: 'POST',
                    types: [PAYMENT_APPROVAL_LIST_SUCCESS, PAYMENT_APPROVAL_LIST],
                    // body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                    body
                },
            });
        };

export const getSettlementApprovalList =
    (body: SettlementApprovalListReq) =>
        async (dispatch: any): Promise<SettlementApprovalListRes> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/nonMfTransactions/settlementApprovalList`,
                    method: 'POST',
                    types: [SETTLEMENT_APPROVAL_LIST_SUCCESS, SETTLEMENT_APPROVAL_LIST],
                    // NOTE (CONV-01): body is sent as plaintext (not encryptedBody) intentionally — consistent
                    // with sibling list actions (getPaymentApprovalList, getOrderApprovalList). Only
                    // getOfflinePaymentApproval uses encodeBase64 encryption, which is a different action.
                    body
                },
            });
        };

export const getPaymentDetails =
    (body: CheckerOrderDetailsReq) =>
        async (dispatch: any): Promise<CheckerOrderDetailsRes> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/nonMfTransactions/paymentDetails`,
                    method: 'POST',
                    types: [PAYMENT_DETAILS_SUCCESS, PAYMENT_DETAILS],
                    // body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                    body
                },
            });
        };


export const getPaymentsApproval =
    (body: PaymentsApprovalReq) =>
        async (dispatch: any): Promise<CheckerOrderApprovalRes> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/nonMfTransactions/paymentApproval`,
                    method: 'POST',
                    types: [CHECKER_PAYMENT_APPROVAL_SUCCESS, CHECKER_PAYMENT_APPROVAL],
                    // body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                    body
                },
            });
        };


export const getSettlementApproval =
    (body: SettlementApprovalReq) =>
        async (dispatch: any): Promise<CheckerOrderApprovalRes> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/nonMfTransactions/settlementApproval`,
                    method: 'POST',
                    types: [CHECKER_SETTLEMENT_APPROVAL_SUCCESS, CHECKER_SETTLEMENT_APPROVAL],
                    body
                },
            });
        };

export const getOfflinePaymentApproval =
    (body: OfflinePaymentApprovalReq) =>
        async (dispatch: any): Promise<OfflinePaymentApprovalRes> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/transactions/offlinePaymentApproval`,
                    method: 'POST',
                    types: [CHECKER_OFFLINE_PAYMENT_APPROVAL_SUCCESS, CHECKER_OFFLINE_PAYMENT_APPROVAL],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };

export const getOrderApprovalExcelReport =
    (body: OrderApprovalExcelReportReq) =>
        async (dispatch: any): Promise<Blob> => {
            return await dispatch({
                [CALL_API]: {
                    // NOTE (SAN-16): All three Excel report actions (order/payment/settlement) intentionally share
                    // the same endpoint URL. The backend differentiates the report type by the request body payload,
                    // not by URL path — this is confirmed by design.
                    url: `/onboarding/nonMfTransactions/nonMfOrdersExcelReport`,
                    method: 'POST',
                    types: [ORDER_APPROVAL_EXCEL_REPORT_SUCCESS, ORDER_APPROVAL_EXCEL_REPORT],
                    body,
                    contentType: CONTENT_TYPE.EXCEL,
                },
            });
        };

export const getPaymentApprovalExcelReport =
    (body: PaymentApprovalExcelReportReq) =>
        async (dispatch: any): Promise<Blob> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/nonMfTransactions/nonMfOrdersExcelReport`,
                    method: 'POST',
                    types: [PAYMENT_APPROVAL_EXCEL_REPORT_SUCCESS, PAYMENT_APPROVAL_EXCEL_REPORT],
                    body,
                    contentType: CONTENT_TYPE.EXCEL,
                },
            });
        };

export const getSettlementApprovalExcelReport =
    (body: SettlementApprovalExcelReportReq) =>
        async (dispatch: any): Promise<Blob> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/nonMfTransactions/nonMfOrdersExcelReport`,
                    method: 'POST',
                    types: [SETTLEMENT_APPROVAL_EXCEL_REPORT_SUCCESS, SETTLEMENT_APPROVAL_EXCEL_REPORT],
                    body,
                    contentType: CONTENT_TYPE.EXCEL,
                },
            });
        };
